/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierAdvancedJupyterEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_ADVANCED_JUPYTER_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierAdvancedJupyterEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierAdvancedJupyterEnabledSettingParser.decode(input).map(res => new TierAdvancedJupyterEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierAdvancedJupyterEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierAdvancedJupyterEnabledSettingParser.encode(data);
    }
    static schema() {
        return TierAdvancedJupyterEnabledSettingParser.schema();
    }
}
